import React from "react";
import { SuperAdminDashboard } from "../../components/SuperAdminDashboard";

export function SystemPage() {
  return <SuperAdminDashboard />;
}
